import { render, staticRenderFns } from "./BulkUploadData.vue?vue&type=template&id=b470c960"
import script from "./BulkUploadData.vue?vue&type=script&lang=js"
export * from "./BulkUploadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports